export const apiHost = process.env.REACT_APP_API_HOST_URL
export const appToken = process.env.REACT_APP_APP_TOKEN
export const downloadHost = process.env.REACT_APP_DOWNLOAD_HOST_URL